export default __webpack_public_path__ + "static/media/13-1_en.86ea643e.png";